/**
 * Small-fixes item 23: the PUT body for a landlord's fee override. The server REPLACES the whole
 * override, so a body without `until` keeps the plan and clears the end date -- that is how
 * "same plan, no end date" is saved.
 */
export function feeOverrideBody(planId: string, until: string): { planId: string; until?: string } {
  return { planId, ...(until ? { until } : {}) };
}
